import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import PricingCard from "@/components/PricingCard";
import ComparisonTable from "@/components/ComparisonTable";
import { SectionHeader } from "@/components/SectionHeader";
import { agentPackages, agencyPackages } from "@/data/packages";

export default function Pricing() {
  return (
    <div>
      <section className="pt-16 md:pt-24 pb-16 md:pb-20 border-b border-[#27272a] relative overflow-hidden">
        <div className="absolute inset-0 radial-fade" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <div className="eyebrow mb-6">
              <span className="gold-line" />
              Pricing
            </div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
              Simple, transparent, <br />
              <span className="text-[#C8A24B]">built for how agents work.</span>
            </h1>
            <p className="mt-8 text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
              A setup fee to build the system. A monthly fee to keep it sharp.
              All prices in USD.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader eyebrow="Agent Plans" title="For individual professionals." />
          <div className="mt-14 grid lg:grid-cols-3 gap-6 lg:gap-8">
            {agentPackages.map((pkg, i) => (
              <PricingCard key={pkg.id} pkg={pkg} index={i} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 border-t border-[#27272a] bg-[#0d0d0d]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader eyebrow="Agency Plans" title="For teams, brokerages, and firms." />
          <div className="mt-14 grid lg:grid-cols-3 gap-6 lg:gap-8">
            {agencyPackages.map((pkg, i) => (
              <PricingCard key={pkg.id} pkg={pkg} index={i} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 border-t border-[#27272a]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionHeader
            eyebrow="Compare"
            title="How the options compare."
            subtitle="An honest look at DIY, freelancers, typical agencies, and Agent Marketing."
          />
          <div className="mt-14">
            <ComparisonTable />
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 border-t border-[#27272a] bg-[#0d0d0d]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-white leading-tight">
            Not sure which plan fits?
          </h2>
          <p className="text-[#a1a1aa] mt-6 max-w-xl mx-auto">
            Start with a short fit conversation. We will look at your current
            presence, recommend the right entry point, and only build what
            makes sense.
          </p>
          <div className="mt-10 flex justify-center gap-4 flex-wrap">
            <Link to="/contact" className="btn-gold">
              Build My Growth Plan <ArrowRight size={16} />
            </Link>
            <Link to="/faq" className="btn-outline">
              Read the FAQ
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
